import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Routes from './routes';

import AppProviders from './hooks';
import GLobalStyle from './styles/global';
import Header from './components/Header';

const App: React.FC = () => {
  return (
    <>
      <BrowserRouter>
        <AppProviders>
          <Header />
          <ToastContainer />

          <Routes />
        </AppProviders>

        <GLobalStyle />
      </BrowserRouter>
    </>
  );
};

export default App;
